import React from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import { Container, RightContainer, Title, DropdownContainer } from './styled';
import  DropdownRelevancia  from './DropdownRelevancia';
import {  useSelector } from 'react-redux';


const Relevancia = () => {
  const thisCard = useSelector((state) => state.card);
	
return (
  <Container >    
    <NotesIcon fontSize='small' />
      <RightContainer>
        <Title>Relevância</Title>
        <DropdownContainer>
					<DropdownRelevancia title='Selecione' />
				</DropdownContainer>
      </RightContainer>
  </Container>
  )
};

export default Relevancia;
